import {themeGetter} from 'quickstart/system'

const getTags = theme => {
  const th = themeGetter(theme)

  const border = {
    borderWidth: th('borderWidths.sm'),
    borderStyle: 'solid',
  }

  const withoutVisibleBorder = color => ({
    ...border,
    borderColor: color,
    backgroundColor: color,
  })

  return {
    default: {
      borderRadius: th('radii.none'),
      ...withoutVisibleBorder(th('colors.tagNeutralColor')),
      backgroundColor: th('colors.tagNeutralColor'),
      ...th('ui.tag'),
      color: th('colors.textColorMuted'),
      fontWeight: th('fontWeights.regular'),
    },
    variants: {
      default: {},
      action: {
        ...th('ui.tag'),
        cursor: 'pointer',
        transition: th('transitions.medium'),
        '&:hover': {
          backgroundColor: th('colors.tagNeutralHover'),
          color: th('colors.textColor'),
        },
      },
      /*
      primary: {
        ...withoutVisibleBorder(th('colors.primary.500')),
        color: th('colors.light.900'),
      },
      secondary: {
        backgroundColor: th('colors.sub.4'),
        color: th('colors.light.900'),
        borderColor: hexToRGBA(th('colors.dark.900'), 0.1),
        ...border,
      },
      dark: {
        backgroundColor: th('colors.dark.700'),
        color: th('colors.light.700'),
        borderColor: th('colors.dark.500'),
        ...border,
      },
      success: {
        backgroundColor: th('colors.success.100'),
        color: th('colors.success.500'),
        borderColor: th('colors.success.200'),
        ...border,
      },
      error: {
        backgroundColor: th('colors.danger.100'),
        color: th('colors.danger.700'),
        borderColor: th('colors.danger.500'),
        ...border,
      },
      warning: {
        backgroundColor: th('colors.warning.100'),
        color: th('colors.warning.700'),
        borderColor: th('colors.warning.500'),
        ...border,
      },
      info: {
        backgroundColor: th('colors.info.100'),
        color: th('colors.info.500'),
        borderColor: th('colors.info.200'),
        ...border,
      },
      1: {...withoutVisibleBorder(th('colors.sub.1'))},
      2: {...withoutVisibleBorder(th('colors.sub.2'))},
      3: {...withoutVisibleBorder(th('colors.sub.3'))},
      4: {...withoutVisibleBorder(th('colors.sub.4'))},
      5: {...withoutVisibleBorder(th('colors.sub.5'))},
      6: {...withoutVisibleBorder(th('colors.sub.6'))},
      */
    },
  }
}

export default getTags
